import React from 'react';
import {IndexRoute, Route} from 'react-router';
import App from './containers/App/App';
import AppWithMenu from './containers/App/AppWithMenu';
import AppLogin from './containers/App/AppLogin';
import Login from './containers/Login/Login';
import SetPassword from './containers/Login/SetPassword';
import Activate from './containers/Login/Activate';
import NotFound from './containers/NotFound';

import EmailTemplate from './containers/EmailTemplate/Page';
import EmailAccount from './containers/Emailaccount/Page';
import EmailLayout from './containers/Emaillayout/Page';
import Image from './containers/Image/Page';
import User from './containers/User/Page';
import Profile from './containers/User/Profile';
import Session from './containers/Session/List';
import Setting from './containers/Setting/Setting';
import Email from './containers/Email/Page';
import Client from './containers/Client/Page';
import Training from './containers/Training/Page';
import Trainingtext from './containers/Trainingtext/Page';
import Vehicle from './containers/Vehicle/Page';
import Driver from './containers/Driver/Page';
import Trainer from './containers/Trainer/Page';
import Document from './containers/Document/Page';
import Checkpoint from './containers/Checkpoint/Page';
import Techtest from './containers/Techtest/Page';
import Template from './containers/Template/Page';
import Trainingtype from './containers/Trainingtype/Page';
import Etrainingtype from './containers/Etrainingtype/Page';
import Reason from './containers/Reason/Page';
import Outro from './containers/Outro/Page';
import Praxe from './containers/Praxe/Page';
import Folder from './containers/Folder/Page';
import Question from './containers/Question/Page';
import Qsection from './containers/Qsection/Page';
import Text from './containers/Text/Page';
import Order from './containers/Order/Page';
import Invoice from './containers/Invoice/Page';
import Forklift from './containers/Forklift/Page';
import Calendar from './containers/Calendar/Page';
import Activitylog from './containers/Activitylog/Page';

const urlPrefix = __URLPREFIX__;

export default (store) => {

	const requireLogin = (nextState, replaceState, cb) => {
		function checkAuth() {
			const { auth: { isLoggedIn }} = store.getState();
			if (!isLoggedIn) {
				replaceState(urlPrefix + '/login?backlink='+encodeURIComponent(nextState.location.pathname + nextState.location.search));
			}
			cb();
		}
		checkAuth();
	};

	return (
		<Route path={urlPrefix+'/'} component={App}>
			<Route onEnter={requireLogin} component={AppWithMenu}>
				<IndexRoute name="training" component={Training} />
				<Route path={urlPrefix + '/user(/:id)'} name="user"  menu="setting" component={User} />
				<Route path={urlPrefix + '/image(/:id)'} name="image" component={Image} />
				<Route path={urlPrefix + '/email(/:id)'} name="email" menu="payment" component={Email} />
				<Route path={urlPrefix + '/session(/:id)'} name="video" component={Session} />
				<Route path={urlPrefix + '/user(/:id)'} name="user"  menu="setting" component={User} />
				<Route path={urlPrefix + '/emailtemplate(/:id)'} name="emailtemplate" menu="setting" component={EmailTemplate} />
				<Route path={urlPrefix + '/emailaccount(/:id)'} name="emailaccount" menu="setting" component={EmailAccount} />
				<Route path={urlPrefix + '/emaillayout(/:id)'} name="emaillayout" menu="setting" component={EmailLayout} />
				<Route path={urlPrefix + '/profile'} name="profile" component={Profile} />
				<Route path={urlPrefix + '/setting'} name="setting" menu="setting" component={Setting} />
				<Route path={urlPrefix + '/folder(/:id)'} name="folder" menu="document" component={Folder} />
				<Route path={urlPrefix + '/question(/:id)'} name="question"  menu="etraining" component={Question} />
				<Route path={urlPrefix + '/qsection(/:id)'} name="etrainqsectioning" menu="etraining" component={Qsection} />
				<Route path={urlPrefix + '/text(/:id)'} name="text" menu="etraining" component={Text} />
				<Route path={urlPrefix + '/order(/:id)'} name="order" menu="etraining" component={Order} />
        <Route path={urlPrefix + '/invoice(/:id)'} name="invoice" menu="etraining" component={Invoice} />
				<Route path={urlPrefix + '/forklift(/:id)'} name="forklift" menu="etraining" component={Forklift} />
				<Route path={urlPrefix + '/calendar(/:id)'} name="calendar" menu="etraining" component={Calendar} />
				<Route path={urlPrefix + '/activitylog'} name="activitylog" menu="etraining" component={Activitylog} />
				<Route path={urlPrefix + '/etrainingtype(/:id)'} name="etrainingtype" menu="etraining" component={Etrainingtype} />

                <Route path="/driver(/:id)" name="driver" menu="evi" component={Driver} />
                <Route path="/vehicle(/:id)" name="vehicle" menu="evi" component={Vehicle} />
                <Route path="/trainer(/:id)" name="trainer" menu="evi" component={Trainer} />
                <Route path="/training(/:id)" name="training" component={Training} />
                <Route path="/techtest(/:id)" name="techtest" component={Techtest} />
                <Route path="/document(/:id)" name="document" component={Document} />
                <Route path="/praxe(/:id)" name="praxe"  menu="setting"  component={Praxe} />
                <Route path="/outro(/:id)" name="outro"  menu="setting"  component={Outro} />
                <Route path="/reason(/:id)" name="reason"  menu="setting"  component={Reason} />
                <Route path="/trainingtext(/:id)" name="trainingtext"  menu="setting"  component={Trainingtext} />
				<Route path="/trainingtype(/:id)" name="trainingtype"  menu="setting"  component={Trainingtype} />
                <Route path="/checkpoint(/:id)" name="checkpoint" menu="setting" component={Checkpoint} />
                <Route path="/client(/:id)" name="client" menu="evi" component={Client} />
                <Route path="/template(/:id)" name="template" menu="setting" component={Template} />
			</Route>
			<Route component={AppLogin}>
				<Route path={urlPrefix + '/login'} name="login" component={Login} />
				<Route path={urlPrefix + '/set-password(/:token)'} name="setpassword" component={SetPassword} />
				<Route path={urlPrefix + '/activate(/:token)'} name="setpassword" component={Activate} />
			</Route>
			<Route path="*" component={NotFound} status={404}/>

		</Route>
	);
};




// WEBPACK FOOTER //
// ./src/routes.js